import SellerTableFilter from './seller-table-filter';

export default SellerTableFilter;